module.exports = __webpack_public_path__ + "static/media/onboard-step-1.22a6a39e.png";